//var firebase = require('firebase');
// import * as firebase from 'firebase/app';
import { firebase } from '@firebase/app'
import '@firebase/analytics'

// source: 
export const AVAILABLE_EVENTS = {
    search: "search",
    select_content: "select_content",	//content_type, item_id
    login: "login",
    join_group: "join_group",
    sign_up: "sign_up",
    spend_virtual_currency: "spend_virtual_currency",
    present_offer: "present_offer",     //item_id, item_name, item_category
    share: "share",  //content_type, item_id
    add_to_cart: "add_to_cart",  //quantity, item_category, item_name, item_id, item_location_id, value, price, currency
    view_item: "view_item"  //item_id, item_location_id
}

// source: 
export const AVAILABLE_PARAMS = {
    select_content: {
        items: {
            id: "id",
            name: "name",
            brand: "brand",
            category: "category",
            coupon: "coupon",
            list_name: "list_name",
            list_position: "list_position",
        },
        content_type: "content_type",
        promotions: "promotions"
    }
}

export const captureEvent = ({event, params}) =>{
    firebase.analytics().logEvent( event, params );
};


// WEBPACK FOOTER //
// ./src/third-party/firebase/services/firebaseService.js